/**
 * Timer: 경과 시간 표시.
 *
 * v1 원본: RenewalComponents/SVContent/Header/Timer/StopwatchTimer/StopwatchPresenter.js
 * v2 변환: 단일 함수형 컴포넌트
 */
import React, { useState, useEffect, useRef } from 'react';
import { useAppSelector } from '@/store/hooks';
import { getSyncedNow } from '@/utils/timeOffset';

const Timer: React.FC = () => {
  const startDatetime = useAppSelector((s) => s.local.startDatetime);
  const fallbackStartTime = useRef(getSyncedNow());
  const actualStartTime = startDatetime ?? fallbackStartTime.current;

  const [elapsed, setElapsed] = useState(() => {
    const diffSec = Math.floor((getSyncedNow() - actualStartTime) / 1000);
    return Math.max(0, diffSec);
  });

  useEffect(() => {
    const updateElapsed = () => {
      const diffSec = Math.floor((getSyncedNow() - actualStartTime) / 1000);
      setElapsed(Math.max(0, diffSec));
    };

    updateElapsed();

    const t = setInterval(updateElapsed, 1000);
    return () => clearInterval(t);
  }, [actualStartTime]);

  const hours = Math.floor(elapsed / 3600);
  const minutes = Math.floor((elapsed % 3600) / 60);
  const seconds = elapsed % 60;

  const pad = (n: number) => String(n).padStart(2, '0');

  const renderTime = () => {
    if (hours > 0) {
      return minutes > 0 ? <>{hours}시간 {minutes}분</> : <>{hours}시간</>;
    }
    if (minutes > 0) {
      return seconds > 0 ? <>{minutes}분 {seconds}초</> : <>{minutes}분</>;
    }
    return <>{seconds}초</>;
  };

  return (
    <dl className="remainingTime">
      <dt className="blind">화상대화 사용시간</dt>
      <dd>{renderTime()} 진행중</dd>
    </dl>
  );
};

export default Timer;
